import { createAction } from '@reduxjs/toolkit';

export const digitalUpdateId = createAction('digital/updateId');
export const digitalUpdateUID = createAction('digital/updateUid');
export const digitalUpdateSID = createAction('digital/updateSid');
export const digitalUpdateIsAdded = createAction('digital/updateIsAdded');
export const digitalUpdateIsActive = createAction('digital/updateIsActive');

export const digitalStore = createAction('digital/store');
export const digitalClear = createAction('digital/clear');

export const digitalUpdateRequest = createAction('digital/updateRequest');
export const digitalUpdateError = createAction('digital/updateError');
export const digitalUpdateStore = createAction('digital/updateStore');

export const digitalUpdateItems = createAction('digital/updateItems');
export const digitalUpdateLists = createAction('digital/updateLists');

export const digitalUpdatePostLayout = createAction('digital/updatePostLayout');
export const digitalUpdatePostBackgroundColor = createAction('digital/updatePostBackgroundColor');
export const digitalUpdatePostTextColor = createAction('digital/updatePostTextColor');
export const digitalUpdatePostButtonBackgroundColor = createAction('digital/updatePostButtonBackgroundColor');
export const digitalUpdatePostButtonTextColor = createAction('digital/updatePostButtonTextColor');

export const digitalUpdateIsPostFavourite = createAction('digital/updateIsPostFavourite');
export const digitalUpdateIsPostCart = createAction('digital/updateIsPostCart');
export const digitalUpdateIsPostShadow = createAction('digital/updateIsPostShadow');
export const digitalUpdateIsDisplayCart = createAction('digital/updateIsDisplayCart');
export const digitalUpdateIsDisplayAvailable = createAction('digital/updateIsDisplayAvailable');

export const digitalUpdateCategories = createAction('digital/updateCategories');
export const digitalUpdateProperties = createAction('digital/updateProperties');
export const digitalUpdateLabels = createAction('digital/updateLabels');

export const digitalUpdateIsShippingName = createAction('digital/updateIsShippingName');
export const digitalUpdateIsShippingPhone = createAction('digital/updateIsShippingPhone');
export const digitalUpdateIsShippingEmail = createAction('digital/updateIsShippingNEmail');
export const digitalUpdateIsShippingAddress = createAction('digital/updateIsShippingAddress');
export const digitalUpdateIsShippingComment = createAction('digital/updateIsShippingComment');

export const digitalUpdateIsShippingNameRequired = createAction('digital/updateIsShippingNameRequired');
export const digitalUpdateIsShippingPhoneRequired = createAction('digital/updateIsShippingPhoneRequired');
export const digitalUpdateIsShippingEmailRequired = createAction('digital/updateIsShippingNEmailRequired');
export const digitalUpdateIsShippingAddressRequired = createAction('digital/updateIsShippingAddressRequired');
export const digitalUpdateIsShippingCommentRequired = createAction('digital/updateIsShippingCommentRequired');

export const digitalUpdateShippingFields = createAction('digital/updateShippingFields');

export const digitalUpdateLayout = createAction('digital/updateLayout');
export const digitalUpdateView = createAction('digital/updateView');
export const digitalUpdateListView = createAction('digital/updateListView');

export const digitalUpdateHeadingTitle = createAction('digital/updateHeadingTitle');
export const digitalUpdateHeadingDescription = createAction('digital/updateHeadingDescription');
export const digitalUpdateHeadingTextAlign = createAction('digital/updateHeadingTextAlign');
export const digitalUpdateHeadingImage = createAction('digital/updateHeadingImage');
export const digitalUpdateHeadingDivider = createAction('digital/updateHeadingDivider');

export const digitalUpdateSectionIsBackground = createAction('digital/updateSectionIsBackground');
export const digitalUpdateSectionTextColor = createAction('digital/updateSectionTextColor');
export const digitalUpdateSectionBackgroundColor = createAction('digital/updateSectionBackgroundColor');
export const digitalUpdateSectionOpacity = createAction('digital/updateSectionOpacity');
export const digitalUpdateSectionIsFullWidth = createAction('digital/updateSectionIsFullWidth');
export const digitalUpdateSectionShadow = createAction('digital/updateSectionShadow');
export const digitalUpdateSectionShadowColor = createAction('digital/updateSectionShadowColor');
export const digitalUpdateSectionPadding = createAction('digital/updateSectionPadding');
export const digitalUpdateSectionMargin = createAction('digital/updateSectionMargin');
export const digitalUpdateSectionBackgroundType = createAction('digital/updateSectionBackgroundType');
export const digitalUpdateSectionBackgroundImage = createAction('digital/updateSectionBackgroundImage');
export const digitalUpdateSectionGradientColor1 = createAction('digital/updateSectionGradientColor1');
export const digitalUpdateSectionGradientColor2 = createAction('digital/updateSectionGradientColor2');
export const digitalUpdateSectionGradientDirection = createAction('digital/updateSectionGradientDirection');
export const digitalUpdateSectionGradientOffset = createAction('digital/updateSectionGradientOffset');
export const digitalUpdateSectionBorder = createAction('digital/updateSectionBorder');
export const digitalUpdateSectionBorderColor = createAction('digital/updateSectionBorderColor');
export const digitalUpdateSectionShadowBorderColor = createAction('digital/updateSectionShadowBorderColor');
export const digitalUpdateSectionShape = createAction('digital/updateSectionShape');

export const digitalUpdateItemShadow = createAction('digital/updateItemShadow');
export const digitalUpdateItemShadowColor = createAction('digital/updateItemShadowColor');
export const digitalUpdateItemBorder = createAction('digital/updateItemBorder');
export const digitalUpdateItemBorderColor = createAction('digital/updateItemBorderColor');
export const digitalUpdateItemShape = createAction('digital/updateItemShape');
export const digitalUpdateItemTextColor = createAction('digital/updateItemTextColor');
export const digitalUpdateItemBackgroundColor = createAction('digital/updateItemBackgroundColor');
